import { WidgetsConfigList } from 'common/widgetsConfig';
import EmbedCode from 'components/EmbedCode/EmbedCode';
import ButtonsSection from 'components/SettingsWidget/ButtonsSection';
import SettingsWidget from 'components/SettingsWidget/SettingsWidget';
import { getFormattedWidth } from 'components/utils';
import { useSettingsWidgetHandler } from 'hooks/useSettingsWidgetHandler';
import React from 'react';
import { useWindowSize } from 'usehooks-ts';
import NewsWidget from 'widgets/NewsWidget';

function NewsWidgetPage() {
  const embedCodeConfig = WidgetsConfigList.news; 
  const {width} = useWindowSize(); 
   const {
    isContainerChecked,
    isTransparentChecked,
    widthValue,
    theme,
    handleChange,
    handleContainerChecked,
    handleThemeChange,
    handleTrasparentChecked,
    handleResetSettings,
    isReset, 
    selectedNews, 
    setSelectedNews, 
    formattedConfig, 
    handleApply,
    handleBlur, 
    config
  } = useSettingsWidgetHandler({ 
    widgetId: embedCodeConfig.container_id,
    widthDefault: 450, 
    defaultNews: embedCodeConfig.defaultNews 
  });
  return (
    <div className='pt-[20px] pb-[40px] w-full flex flex-col items-center'>
      <div className='text-[30px] mulish-600 text-silver'>News Widget</div>
      <div className={`w-full text-sm text-center text-gray dark:text-gray-light_100 mb-4`} style={{ width: width > 768 ? `${config.width}px` : '100%' }}>
          Help your audience keep track of what's happening in the precious metals, mining, crypto, and economic markets with our daily news.
      </div>

      <div className='w-full lg:w-1/2 flex flex-col items-center'>
    
      <NewsWidget config={config}/>

      <SettingsWidget
          widthValue={widthValue}
          theme={theme}
          handleBlur={() => handleBlur(300)}
          isTransparentChecked={isTransparentChecked}
          isContainerChecked={isContainerChecked}
          handleChange={handleChange}
          handleContainerChecked={handleContainerChecked}
          handleThemeChange={handleThemeChange}
          isReset={isReset}
          selectedNews={selectedNews}
          setSelectedNews={setSelectedNews}
          defaultWidth='450'
          handleTrasparentChecked={handleTrasparentChecked}
        />

        <ButtonsSection
          isTransparentChecked={isTransparentChecked}
          widthValue={widthValue}
          theme={theme}
          formattedConfig={formattedConfig}
          handleApply={handleApply}
          embedCodeConfig={embedCodeConfig}
          handleResetSettings={handleResetSettings}
        />

        <EmbedCode
          width={getFormattedWidth(config.useContainerSize, widthValue)}
          isTransparent={isTransparentChecked}
          colorTheme={theme}
          formattedConfig={formattedConfig}
          embedCodeConfig={embedCodeConfig}
        />

      </div>
    </div>
  );
}

export default NewsWidgetPage;